import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Icon } from "@chakra-ui/react";
import { FaRegStar, FaStar } from "react-icons/fa";
const RatingStars = ({ rating }) => {
    const totalStars = 5;
    const filledStars = Math.floor(rating);
    const halfStar = rating - filledStars >= 0.5;
    const emptyStars = totalStars - filledStars - (halfStar ? 1 : 0);
    return (_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [Array(filledStars)
                .fill("")
                .map((_, i) => (_jsx(Icon, { as: FaStar, w: "16px", h: "16px", color: "#E3BD36" }, i))), halfStar && (_jsx(Icon, { as: FaStar, w: "16px", h: "16px", color: "#E3BD36", style: { clipPath: "inset(0 50% 0 0)" } })), Array(emptyStars)
                .fill("")
                .map((_, i) => (_jsx(Icon, { as: FaRegStar, w: "16px", h: "16px", color: "#C6C6C6", sx: { stroke: "#C6C6C6", strokeWidth: "1px" } }, i + filledStars + 1)))] }));
};
export default RatingStars;
